import React from 'react'

import styled, { useTheme } from 'styled-components'
import { useIsUserVerified } from 'state/user/hooks'
import { Text, Modal, Flex } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'
import { StatusBar } from '../components'

interface AwaitingVerificationModalProps {
  onDismiss?: () => void
  onVerificationDeclined?: () => void
}

const StyledModalWrapper = styled(Flex)`
  flex-direction: column;
  margin-top: 24px;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: 100%;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    width: 493px;
  }
`

const AwaitingWalletVerificationModal: React.FC<AwaitingVerificationModalProps> = (props) => {
  const { t } = useTranslation()
  const { onDismiss = () => null, onVerificationDeclined = () => null } = props
  const { colors } = useTheme()
  const isUserVerified = useIsUserVerified()

  const closeModalHandler = () => {
    onVerificationDeclined()
    onDismiss()
  }

  return (
    <Modal onDismiss={closeModalHandler} title={t('web3Modal.signInWallet')}>
      <StyledModalWrapper>
        <Flex maxWidth="340px">
          <Text color={colors.gray6}>{t('web3Modal.signInWalletDescription')}</Text>
        </Flex>
      </StyledModalWrapper>
      <Flex mt="24px" width="100%" justifyContent="center">
        <StatusBar isUserVerified={isUserVerified} isLoading />
      </Flex>
    </Modal>
  )
}

export default AwaitingWalletVerificationModal
